import { PrimaryInput } from "components/input";
import { Section, SectionTitle } from "modules/selections/common";
import React from "react";
import { BaseTemplate, ComponentType } from "templates/src/types";

import { ToneOfVoice } from "modules/selections/tone-of-voice-selection";
import { useSelectedTemplateContext } from "context/selected-template-context";

const FieldRenderer = ({
  field,
}: {
  field: BaseTemplate["fields"][number];
}) => {
  const { getValue, onValueChange } = useSelectedTemplateContext();

  if (field.type === ComponentType.TextArea) {
    return (
      <PrimaryInput
        multiline
        fullWidth
        size="small"
        maxRows={20}
        value={getValue(field.id)}
        onChange={(e) => {
          onValueChange(e.target.value, field.id);
        }}
        sx={{
          borderRadius: "10px",
        }}
        placeholder={field.placeholder}
      />
    );
  }

  if (field.type === ComponentType.ToneOfVoice) {
    return (
      <ToneOfVoice
        hideTitle
        value={getValue(field.id)}
        onChange={(value) => {
          onValueChange(value, field.id);
        }}
      />
    );
  }

  return null;
};

const TemplateFormRenderer = ({ template }: { template: BaseTemplate }) => {
  return (
    <>
      {template.fields.map((field) => {
        return (
          <Section>
            <SectionTitle
              required={field.required}
              optional={field.optional}
              description={field.description}
            >
              {field.label}
            </SectionTitle>
            <FieldRenderer field={field} />
          </Section>
        );
      })}
    </>
  );
};

export default TemplateFormRenderer;
